import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { LEAD_TYPES } from "../services/leadEmail";
import { submitLegacyLead } from "../services/legacyLeadSubmission";

function ContactFormGoElectric() {
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const form = useForm();
  const { register, handleSubmit, formState } = form;
  const { errors } = formState;

  const marketingCampaign = async (data, slug) => {
    if (data.website) {
      console.warn("Spam detected (honeypot).");
      return;
    }
    try {
      setSubmitting(true);
      await submitLegacyLead({
        collectionName: slug,
        formData: data,
        firestoreData: {
          name: data.name ?? "",
          email: data.email ?? "",
          phone: data.phone ?? "",
          dealership: data.dealership ?? "",
          model: data.model ?? "",
          text: "",
        },
        leadPayload: {
          type: LEAD_TYPES.CAMPAIGN_TESTDRIVE,
          vehicle: {
            model: data.model ?? "",
          },
          campaign: {
            slug,
          },
          title: "Go Electric Roadshow 2025",
          message: `Заявка за ${data.model ?? "електрически модел"}`,
        },
      });

      navigate("/thank-you-testdrive");
    } catch (error) {
      console.error("Грешка при запис в Firebase:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const slug = "go-electric-roadshow-2025";

  return (
    <form
      onSubmit={handleSubmit((data) => marketingCampaign(data, slug))}
      id="templateCampaignForm"
      className="px-8 py-16 lg:px-48"
      noValidate
    >
      {/* Honeypot field */}
      <input
        type="text"
        name="website"
        {...register("website")}
        tabIndex="-1"
        autoComplete="off"
        className="hidden"
      />

      {/* Име */}
      <div className="mt-8">
        <label htmlFor="name" className="text-gray-500">
          Име
        </label>
        <input
          type="text"
          id="name"
          name="name"
          {...register("name", {
            required: {
              value: true,
              message: "Моля, въведете Вашето име",
            },
          })}
        />
        <p className="text-red-500">{errors.name?.message}</p>
      </div>

      {/* Имейл */}
      <div className="mt-4">
        <label htmlFor="email" className="text-gray-500">
          Имейл
        </label>
        <input
          type="email"
          id="email"
          name="email"
          {...register("email", {
            required: {
              value: true,
              message: "Моля, въведете имейл-адрес",
            },
            pattern: {
              value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
              message: "Невалиден имейл-адрес",
            },
          })}
        />
        <p className="text-red-500">{errors.email?.message}</p>
      </div>

      {/* Телефон */}
      <div className="mt-4">
        <label htmlFor="phone" className="text-gray-500">
          Телефон
        </label>
        <input
          type="text"
          id="phone"
          name="phone"
          {...register("phone", {
            required: {
              value: true,
              message: "Моля, въведете телефонен номер",
            },
            pattern: {
              value: /^(?:\+359|0)\s?\d{1,2}\s?\d{3}\s?\d{3,4}$/,
              message: "Моля, въведете валиден телефонен номер",
            },
          })}
        />
        <p className="text-red-500">{errors.phone?.message}</p>
      </div>

      <div className="mt-4">
        <label htmlFor="dealership" className="text-gray-500">
          Изберете град
        </label>
        <select
          name="dealership"
          id="dealership"
          defaultValue=""
          {...register("dealership", {
            required: {
              value: true,
              message: "Моля, изберете представителство",
            },
          })}
        >
          <option value="" disabled hidden>
            Моля, изберете
          </option>
          <option value="liulin2@motopfohe.bg">София Люлин</option>
          <option value="mladost@motopfohe.bg">София Младост</option>
          <option value="blagoevgrad@motopfohe.bg">Благоевград</option>
          <option value="burgas@motopfohe.bg">Бургас</option>
          <option value="varna@motopfohe.bg">Варна</option>
          <option value="velikotarnovo@motopfohe.bg">Велико Търново</option>
          <option value="gabrovo@motopfohe.bg">Габрово</option>
          <option value="dobrich@motopfohe.bg">Добрич</option>
          <option value="montana@motopfohe.bg">Монтана</option>
          <option value="pleven@motopfohe.bg">Плевен</option>
          <option value="plovdiv@motopfohe.bg">Пловдив</option>
          <option value="russe@motopfohe.bg">Русе</option>
          <option value="starazagora@motopfohe.bg">Стара Загора</option>
          <option value="smolyan@motopfohe.bg">Смолян</option>
          <option value="forsh@motopfohe.bg">Шумен</option>
          <option value="g.draganov@autobox.bg">Хасково</option>
        </select>
        <p className="text-red-500">{errors.dealership?.message}</p>
      </div>

      <div className="mt-4">
        <label htmlFor="model" className="text-gray-500">
          Изберете модел
        </label>
        <select
          name="model"
          id="model"
          defaultValue=""
          {...register("model", {
            required: {
              value: true,
              message: "Моля, изберете модел",
            },
          })}
        >
          <option value="" disabled hidden>
            Моля, изберете
          </option>
          <option value="Explorer">Explorer</option>
          <option value="Capri">Capri</option>
          <option value="Puma">Puma</option>
          <option value="Mustang Mach-E">Mustang Mach‑E</option>
        </select>
        <p className="text-red-500">{errors.model?.message}</p>
      </div>

      <button
        type="submit"
        disabled={submitting}
        className="px-16 py-2 mx-auto mt-8 text-white border rounded-full bg-fordBlue disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {submitting ? "Изпращане…" : "Изпрати"}
      </button>
    </form>
  );
}

export default ContactFormGoElectric;
